import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { EventService } from '@common/event.service';
import { IdentityClientService } from '@identity/identity-client.service';
import { IdentityCommonService } from '@identity/identity-common.service';
import { IdentityConstants } from '@identity/identity-constants.service';
import { IdentityUserService } from '@identity/identity-user.service';

@Component({
  selector: 'sas-sign-user',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  templateUrl: './sas-sign-user.component.html',
  styleUrl: './sas-sign-user.component.scss'
})
export class SasSignUserComponent {
  private destroyRef = inject(DestroyRef);
  translate = inject(TranslateService);
  identityUserService = inject(IdentityUserService);
  eventService = inject(EventService);
  sasIdentityConstant = inject(IdentityConstants).identityConstants;
  identityCommonService = inject(IdentityCommonService);
  identityClientService = inject(IdentityClientService);

  signInText: string = 'SIGN_IN';
  signOutText: string = 'SIGN_OUT';
  isLogged: boolean = this.userIsLogged();
  username: string = this.identityUserService.getUser()?.username || '';
  clientUrl: string = this.identityClientService.get().url;

  ngOnInit() {
    this.updateState();

    this.setupListeners();
  }

  setupListeners() {
    this.eventService.getEvent(this.sasIdentityConstant.eventLoginSuccess)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => this.updateState());
    this.eventService.getEvent(this.sasIdentityConstant.eventRegisterSuccess)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => this.updateState());
    this.eventService.getEvent(this.sasIdentityConstant.eventLogoutSuccess)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => this.updateState());
    this.eventService.getEvent(this.sasIdentityConstant.eventSessionTimeout)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => this.updateState());
  }

  updateState() {
    this.isLogged = this.userIsLogged();

    this.username = this.isLogged ? this.identityUserService.getUser()?.username : '';
  }

  userIsLogged() {
    return this.identityUserService.isLogged();
  }

  signout() {
    this.identityCommonService.logout();
  }
}
